import { useEffect } from "react";
import { AuthFunctions } from "../utils/FrontendAuthFunctions";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import {
  setCalendars,
  setHolidays,
  setPlaces,
  setEvents,
} from "../store/features/cacheSlice";
import { setInfo } from "../store/features/currentSlice";

type LogoutProps = {
  removeCookieFunc: () => void;
};

export default function Logout({ removeCookieFunc }: LogoutProps) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onLoad = async () => {
    //reset all redux
    dispatch(setHolidays(null));
    dispatch(setCalendars(null));
    dispatch(setPlaces(null));
    dispatch(setEvents(null));
    dispatch(setInfo(null));
    //removeCookie("session",null);
    if (typeof removeCookieFunc === "function") {
      removeCookieFunc();
    }
    await AuthFunctions.logout(navigate);
  };

  useEffect(() => {
    onLoad();
  }, []);
  return <></>;
}
